import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { OnboardingGoalQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";
import { onboardingHubImageByTaskType } from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/constants";

const BG_STYLES_BY_TASK_TYPE = {
    [OnboardingGoalQuestionType.SetUpAlerts]: "-24px 0px / 100% 100%",
    [OnboardingGoalQuestionType.UploadListOfCompanies]: "-16px 1px / 100% 100%",
    [OnboardingGoalQuestionType.ConnectMyCrm]: "-40px -1px / 100% 100%",
    [OnboardingGoalQuestionType.CreateContactProfile]: "100% / cover",
    [OnboardingGoalQuestionType.DownloadChromeExtension]: "100% / cover",
};
const WIDTH_STYLES_BY_TASK_TYPE = {
    [OnboardingGoalQuestionType.SetUpAlerts]: "349.412px",
    [OnboardingGoalQuestionType.SetUpIntentAlerts]: "auto",
    [OnboardingGoalQuestionType.CreateContactProfile]: "100%",
    [OnboardingGoalQuestionType.UploadListOfCompanies]: "354.61px",
    [OnboardingGoalQuestionType.SyncMyCrm]: "375px",
    [OnboardingGoalQuestionType.DownloadChromeExtension]: "100%",
    [OnboardingGoalQuestionType.UploadSuppressionList]: "373px",
    [OnboardingGoalQuestionType.ConnectMyCrm]: "419.831px",
    [OnboardingGoalQuestionType.ResearchSpecificCompany]: "384px",
};
const HEIGHT_STYLES_BY_TASK_TYPE = {
    [OnboardingGoalQuestionType.SyncMyCrm]: "199px",
    [OnboardingGoalQuestionType.DownloadChromeExtension]: "199px",
    [OnboardingGoalQuestionType.ConnectMyCrm]: "197px",
    [OnboardingGoalQuestionType.ResearchSpecificCompany]: "199px",
};

export const StyledOnboardingHubContentDescription = styled.div`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    overflow: hidden;
    font-feature-settings: "liga" off;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: -4px;
`;
export const StyledOnboardingHubContentBody = styled(FlexColumn)<{ isInSidebar?: boolean }>`
    gap: ${({ isInSidebar = false }) => (isInSidebar ? "8px" : "12px")};
`;

export const StyledOnboardingHubCardContent = styled(FlexColumn)`
    overflow: visible;
    gap: 10px;
    width: 100%;
`;

export const StyledOnboardingHubContentText = styled.div`
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[400])};
    font-size: 13px;
    line-height: 18px;
    font-feature-settings: "liga" off;
`;

export const StyledOnboardingHubContentLink = styled(FlexRow)`
    ${setFontVariant("button", colorsPalettes.blue[400])};
    align-items: center;
    gap: 4px;
    cursor: pointer;

    &:hover {
        color: ${colorsPalettes.blue[500]};

        svg path {
            fill: ${colorsPalettes.blue[500]};
        }
    }
`;

export const StyledOnboardingTaskImageWrapper = styled.div`
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
    width: 100%;
`;

export const StyledOnboardingTaskImage = styled.div<{ taskType: OnboardingGoalQuestionType }>`
    width: ${({ taskType }) => WIDTH_STYLES_BY_TASK_TYPE[taskType] || "381px"};
    height: ${({ taskType }) => HEIGHT_STYLES_BY_TASK_TYPE[taskType] || "198px"};
    flex-shrink: 0;

    background: url(${({ taskType }) => onboardingHubImageByTaskType[taskType]}) lightgray
        ${({ taskType }) => BG_STYLES_BY_TASK_TYPE[taskType] || "50% / cover"} no-repeat;
`;
export const StyledOnboardingHubContentSmallDescription = styled.div`
    ${setFontVariant("dataTable2", colorsPalettes.carbon[400])};
    text-overflow: ellipsis;
    white-space: nowrap;
`;
